import React, { useEffect } from 'react';
import Geoport from '../components/geoport';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';
import { GEOLINK } from '../config';

const Geoportal = () => {
    useDocumentTitle("Geoportal");

    useEffect(() => {
        const win = window.open(GEOLINK, "_blank");
        win.focus();
    }, []);

    return (
        <div>
            <PageHeader tittle="GEOPORTAL" />
            <div className='md:px-5 px-1'>
                <div className='flex flex-col w-full'>
                    {/* La pagina que intentas acceder no existe, por favor verifica la url o vuelve al inicio. */}
                    <p className='text-center sm:w-[50%] py-6 mx-auto text-2xl sm:text-3xl font-light'>La vista del Geoportal se ha mostrado en una nueva pestaña para mayor comodidad. por favor diríjase a ella.</p>
                    <p className='text-center sm:w-[50%] py-6 mx-auto text-2xl sm:text-3xl font-light'>En caso contrario, <a target='_BLANK' className='text-blue-800 underline' href={GEOLINK} >click Aquí.</a></p>
                </div>
            </div>
        </div>
    );
}

export default Geoportal;